const errors = {
    notAuthorized: 'Ошибка авторизации',
    forbidden: 'Операция запрещена',
    notFound: 'Не найдено',
    unknown: 'Неизвестная ошибка',
    tooLarge: 'Превышен размер запроса',
};

export const errorFormatter = key => errors[key] || errors.unknown;
